/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { arrayOf, string } from 'prop-types';
import classNames from 'classnames';
import { ReviewCard } from '@landtrustinc/design-system';
import { propTypes } from '../../util/types';

import css from './Reviews.module.css';

const ReviewsComponent = props => {
  const { className, rootClassName, reviews, intl, providerFirst } = props;
  const classes = classNames(rootClassName || css.root, className);

  if (!reviews || !reviews.length) {
    return null;
  }

  return (
    <ul className={classes}>
      {reviews.map(r => {
        const author = providerFirst ? r.provider : r.customer;
        const reply = providerFirst ? r.customer : r.provider;

        if (!author) {
          return null;
        }

        // Parse review questions for availability badge
        let reviewQuestions = null;
        try {
          reviewQuestions = author.reviewQuestions
            ? typeof author.reviewQuestions === 'string'
              ? JSON.parse(author.reviewQuestions)
              : author.reviewQuestions
            : null;
        } catch (e) {
          // Skip invalid JSON
        }

        // Format date
        const authorDate = intl.formatDate(new Date(author.createdAt), {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        });

        // Get avatar image URL
        const authorAvatar =
          author.author?.profileImage?.attributes?.variants?.['square-small']?.url;

        // Get display name
        const authorName =
          author.author?.attributes?.profile?.displayName ||
          intl.formatMessage({ id: 'Reviews.guest' });

        // Get photos
        const authorImages = author.photos || [];

        // Build replies array if reply exists
        const replies = [];
        if (reply) {
          const replyDate = intl.formatDate(new Date(reply.createdAt), {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          });

          const replyAvatar =
            reply.author?.profileImage?.attributes?.variants?.['square-small']?.url;

          const replyName = reply.author?.attributes?.profile?.displayName || 'User';

          replies.push({
            avatarSrc: replyAvatar,
            content: reply.reviewContent,
            date: replyDate,
            label: providerFirst
              ? intl.formatMessage({ id: 'Reviews.guest' })
              : intl.formatMessage({ id: 'Reviews.landowner' }),
            name: replyName,
            rating: reply.avgRating,
          });
        }

        const reviewId = author?.id?.uuid || author?.id;

        return (
          <li
            key={`Review_${reviewId || author?.id}`}
            id={reviewId ? `review-${reviewId}` : undefined}
            className={css.reviewItem}
          >
            <ReviewCard
              availabilityBadge={
                reviewQuestions?.harvestSuccessfull
                  ? {
                      text: 'Successful Harvest',
                      variant: 'primary',
                    }
                  : undefined
              }
              avatarSrc={authorAvatar}
              content={author.reviewContent}
              date={authorDate}
              images={authorImages}
              name={authorName}
              rating={author.avgRating}
              replies={replies.length > 0 ? replies : undefined}
            />
          </li>
        );
      })}
    </ul>
  );
};

ReviewsComponent.defaultProps = {
  className: null,
  rootClassName: null,
  reviews: [],
};

ReviewsComponent.propTypes = {
  className: string,
  rootClassName: string,
  reviews: arrayOf(propTypes.review),

  // from injectIntl
  intl: intlShape.isRequired,
};

const Reviews = injectIntl(ReviewsComponent);

export default Reviews;
